import { useState } from 'react';

import { FilterCollapseKeys } from '@/apps/appCreator/components/CarFilterCollapse';

type TProps = {
  initShow?: boolean;
};

export default function useFilterProps(props?: TProps) {
  const [showFilter, setShowFilter] = useState(props?.initShow ?? true);
  const [collapseActiveKey, setCollapseActiveKey] = useState<
    FilterCollapseKeys | FilterCollapseKeys[] | undefined
  >();

  return {
    collapseActiveKey,
    showFilter,
    onChangeShow: (v: boolean) => setShowFilter(v),
    onChangeActiveKey: (keys: FilterCollapseKeys | FilterCollapseKeys[]) =>
      setCollapseActiveKey(keys),
  } as const;
}
